import { action } from 'mobx';
import { FieldType, MobxFieldControl } from './MobxFieldControl';

export interface IBaseFormError {
  [key: string]: {
    message: string;
    params?: { [key: string]: string };
  };
}

export abstract class BaseForm {
  _isTouched: boolean = false;

  protected abstract get _fields(): MobxFieldControl[];

  protected abstract getFieldKeys(): string[];

  protected abstract getFieldByKey(key: string): MobxFieldControl | undefined;

  get isValid(): boolean {
    return !this._fields.find(field => !field.isValid);
  }

  get isTouched(): boolean {
    return this._isTouched || !!this._fields.find(field => field.isTouched);
  }

  get isEmpty(): boolean {
    return !this._fields.find(field => field.value !== undefined);
  }

  get errors(): IBaseFormError {
    return this.getFieldKeys().reduce((errors: any, key) => {
      const field = this.getFieldByKey(key);
      if (field?.isTouched) {
        errors[key] = !field.isValid
          ? field.error
          : field._fieldType === FieldType.DATE && field.getErrorDirectly();
      }
      return errors;
    }, {});
  }

  @action
  toggleTouched(touched: boolean = true) {
    this._isTouched = touched;
  }

  @action
  clear(): void {
    this._isTouched = false;
    this._fields.forEach(field => field.clear());
  }

  @action
  reset() {
    this._fields.forEach(field => field.reset());
  }

  @action
  resetIsTouched() {
    this._fields.forEach(field => field.resetIsTouched());
  }
}
